import api from '../api';
import axios from 'axios';

export default {
    WHATS_APP_EMAIL_SEND: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(`${process.env.REACT_APP_BACKEND_URL_Socket_chat_qr}${api.Whatsapp.WHATS_APP_SEND()}`, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    GET_WHATSAPP_MESSAGE: () => {
        return new Promise((resolve, reject) => {
            axios
                .get(`${process.env.REACT_APP_BACKEND_URL}${api.Whatsapp.GET_WHATSAPP_MESSAGE()}`)
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    WHATSAPP_GETTASKBYID: (id) => {
        return new Promise((res, rej) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Whatsapp.WHATSAPP_getTaskBy(id))
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },

    GET_ALL_ATTACHMENT: (id) => {
        return new Promise((res, rej) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Whatsapp.GET_ALL_ATTACHMENT(id))
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },


    GET_CONTACT_WHATSAPP: (data) => {
        return new Promise((res, rej) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Whatsapp.GET_CONTACT_WHATSAPP(data))
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },
    GET_PROFILE_WHATSAPP: (data) => {
        return new Promise((res, rej) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Whatsapp.GET_All_PROFILE_FOR_WHATSAPP(data))
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },
    CREATE_NEW_CONTACT: (data) => {
        return new Promise((res, rej) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL_Socket_chat_qr + api.Whatsapp.ADD_CONTACT(), data)
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },
    GET_CHAT_BYID_WHATSAPP: (id) => {
        return new Promise((res, rej) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Whatsapp.GET_CHAT_BYID_WHATSAPP(id))
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },
    CLIENT_GENERATE: (data) => {
        return new Promise((res, rej) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL_Socket_chat_qr + api.Whatsapp.CLIENT_GENERATE(), data)
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },

    ADD_WHATSAAP_ATTACHMENT: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(`${process.env.REACT_APP_BACKEND_URL_Socket_chat_qr}${api.Whatsapp.ADD_WHATSAAP_ATTACHMENT()}`, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    CLIENT_GENERATE_QRCODE: (id) => {
        return new Promise((res, rej) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Whatsapp.CLIENT_GENERATE_QRCODE(id))
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },
    GET_ALL_CLIENT: () => {
        return new Promise((res, rej) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Whatsapp.GET_ALL_CLIENT())
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },
    Travel_Contact: (data) => {
        return new Promise((res, rej) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL + api.Whatsapp.Travel_Contact(), data)
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },
    GET_ALL_WHATSAPP_CHAT: () => {
        return new Promise((res, rej) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Whatsapp.GET_ALL_WHATSAPP_CHAT())
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },

    GET_BYID_WHATSAPP_PROFILE: (id) => {
        return new Promise((res, rej) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Whatsapp.GET_BYID_WHATSAPP_PROFILE(id))
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },

    DELETE_WHATSAPP_CLIENT: (id, data) => {
        return new Promise((res, rej) => {
            axios
                .put(process.env.REACT_APP_BACKEND_URL + api.Whatsapp.DELETE_WHATSAPP_CLIENT(id), data)
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },
    UPDATE_STATUS: (id) => {
        return new Promise((res, rej) => {
          axios
            .put(
              process.env.REACT_APP_BACKEND_URL + api.Whatsapp.UPDATE_STATUS(id),
              { chatStatus: "read" } 
            )
            .then(response => res(response))
            .catch(err => rej(err));
        });
      },
      


    GET_BY_GROUP_ID_WHATSAPP_PROFILE: (id) => {
        return new Promise((res, rej) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.Whatsapp.GET_BY_GROUP_ID_WHATSAPP_PROFILE(id))
                .then((response) => res(response))
                .catch((err) => rej(err));
        });
    },
};
